export default {
  pickup: {
    path: 'M0-48c-9.8 0-17.7 7.8-17.7 17.4 0 15.5 17.7 30.6 17.7 30.6s17.7-15.4 17.7-30.6c0-9.6-7.9-17.4-17.7-17.4z',
    fillColor: '#2EE47D',
    fillOpacity: 1,
    scale: 0.5,
    strokeColor: 'black',
    strokeWeight: 3
  },
  stop: {
    path: 'M 0 0 A 1 1 0 0 0 0 -32 A 1 1 0 0 0 0 0',
    fillColor: '#fff',
    fillOpacity: 1,
    scale: 0.45,
    strokeColor: 'black',
    strokeWeight: 3
  },
  dropoff: {
    path: 'M22-48h-44v43h16l6 5 6-5h16z',
    fillColor: '#CA3538',
    fillOpacity: 1,
    scale: 0.5,
    strokeColor: 'black',
    strokeWeight: 3
  },
  car: {
    path: 'M45.699 24.145l-7.89-13.293c-.314-.584-1.072-.852-1.721-.852h-7.088v-6c0-1.1-.9-2-2-2h-5c-1.1 0-2 .9-2 2v6h-5.96c-.65 0-1.44.268-1.754.852l-7.921 13.398c-1.301 0-2.365.987-2.365 2.322v12.139c0 1.335 1.064 2.289 2.365 2.289h2.635v3.78c0 2.004 1.328 3.22 3.279 3.22h1.183c1.951 0 3.538-1.216 3.538-3.22v-3.78h20v3.78c0 2.004 1.714 3.22 3.665 3.22h1.184c1.951 0 3.151-1.216 3.151-3.22v-3.78h2.763c1.3 0 2.237-.954 2.237-2.289v-12.139c0-1.335-1-2.427-2.301-2.427zm-37.194 9.71c-1.633 0-2.958-1.358-2.958-3.034 0-1.677 1.324-3.035 2.958-3.035s2.957 1.358 2.957 3.035c0 1.676-1.323 3.034-2.957 3.034zm1.774-9.855l5.384-9.377c.292-.598 1.063-.623 1.713-.623h15.376c.65 0 1.421.025 1.712.623l5.385 9.377h-29.57zm31.343 9.855c-1.632 0-2.957-1.358-2.957-3.034 0-1.677 1.325-3.035 2.957-3.035 1.633 0 2.958 1.358 2.958 3.035 0 1.676-1.325 3.034-2.958 3.034z',
    fillColor: '#0D79F2',
    fillOpacity: 1,
    scale: 0.5,
    strokeColor: 'black',
    strokeWeight: 0
  }
}



// WEBPACK FOOTER //
// ./src/values/map-pin.js